<script>
  import { DataTable } from "carbon-components-svelte";
  import { currentSelectedModel } from "lib/stores.js";

  import ButtonNew from "../../../../lib/components/ButtonNew.svelte";
  import { SectionWrapper } from "paxray-components-svelte";

  $: currentData = $currentSelectedModel;
  let initialData = [];
  let infoData = [];

  $: if (currentData.get) {
    if (currentData.get("elementRegistry")) {
      setTimeout(() => {
        infoData = [];
        initialData = currentData.get("elementRegistry").getAll();
        const data = buildData(currentData.get("elementRegistry").getAll());
        infoData = data;
      }, 500);
    }
  }

  const buildData = (elementRegistry, isChild) => {
    const participant = elementRegistry.filter(
      (element) => element["type"] == "bpmn:Participant"
    );
    let subprocesses = [];

    if (participant.length) {
      subprocesses = elementRegistry.filter(
        (element) =>
          (element["type"] == "bpmn:SubProcess" ||
            element.type == "bpmn:CallActivity") &&
          element["collapsed"] === true &&
          (isChild || element["parent"]["type"] == "bpmn:Participant")
      );
    } else {
      subprocesses = elementRegistry.filter(
        (element) =>
          (element["type"] == "bpmn:SubProcess" ||
            element.type == "bpmn:CallActivity") &&
          element["collapsed"] === true &&
          (isChild || element["parent"]["type"] == "bpmn:Process")
      );
    }

    if (subprocesses.length) {
      const objectData = subprocesses.map((subprocess) => {
        let children = [];
        const childObject = initialData.filter(
          (element) => element["id"] == subprocess.id + "_plane"
        )[0];
        if (childObject) {
          children = initialData
            .filter((element) => element["id"] == subprocess.id + "_plane")[0]
            .children.filter(
              (element) =>
                (element.type == "bpmn:SubProcess" ||
                  element.type == "bpmn:CallActivity") &&
                element.collapsed == true
            );
        }
        return {
          name: subprocess.businessObject.name,
          documentation: subprocess.businessObject.documentation,
          lanes: subprocess.businessObject.lanes,
          type: subprocess["type"]?.split(":")[1],
          children: buildData(children, true),
        };
      });
      return objectData;
    } else {
      return [];
    }
  };

  export const modeler = {};
  export const infoView = {};

  let headers = [
    { key: "version", value: "Version" },
    { key: "created", value: "Created" },
    { key: "actions", value: "Actions" },
  ];

  let rows = [
    {
      id: "a",
      version: "1.5.2",
      created: "Lorem Ispum",
    },
    {
      id: "b",
      version: "2.0",
      created: "Lorem Ipsum",
    },
  ];
</script>

<SectionWrapper fullscreen={true}>
  <div slot="main" class="main">
    <div class="table_container">
      <DataTable {headers} {rows}>
        <svelte:fragment slot="cell" let:row let:cell>
          {#if cell.key === "actions"}
            <div class="button_container">
              <ButtonNew secondary={true} text="Select" on:click />
              <ButtonNew secondary={true} text="Edit" on:click />
              <ButtonNew secondary={true} text="Delete" on:click />
            </div>
          {:else}
            {cell.value}
          {/if}
        </svelte:fragment>
      </DataTable>
    </div>
    <ButtonNew secondary={true} text="Create New Version" on:click />
  </div>
</SectionWrapper>

<style>
  .button_container {
    display: flex;
    gap: 0.5rem;
    color: white !important;
  }

  .main {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .table_container {
    display: flex;
    width: 100%;
    min-width: 100%;
  }
</style>
